import React from "react";
import { Link } from "react-router-dom";
import { Users, Inbox } from "lucide-react";

const TABS = [
  ["clients", "/app/admin/clients", "Clientes", Users],
  ["leads", "/app/admin/leads", "Leads", Inbox],
];

export const SectionTabs = ({ active }) => (
  <div role="tablist" data-testid="clients-section-tabs"
    style={{ display: "flex", gap: 4, borderBottom: "1px solid rgba(255,255,255,0.08)", marginBottom: 24 }}>
    {TABS.map(([key, to, label, Icon]) => {
      const on = key === active;
      return (
        <Link key={key} to={to} role="tab" aria-selected={on} data-testid={`clients-tab-${key}`}
          style={{
            display: "inline-flex", alignItems: "center", gap: 8, padding: "12px 18px", marginBottom: -1,
            color: on ? "#fff" : "#a3a3a3", textDecoration: "none", fontSize: 13, fontWeight: 700,
            letterSpacing: "0.14em", textTransform: "uppercase",
            borderBottom: `2px solid ${on ? "#E11D2E" : "transparent"}`, transition: "color .18s ease, border-color .18s ease",
          }}>
          <Icon size={15} /> {label}
        </Link>
      );
    })}
  </div>
);
